import t from "./index60.mjs";
function a(e) {
  const o = [
    "blue",
    "cyan",
    "grape",
    "red",
    "pink",
    "violet",
    "green",
    "lime",
    "teal",
    "indigo",
    "yellow",
    "orange"
  ], n = t(e), r = Math.floor(n() * o.length);
  return o[r];
}
export {
  a as getRandomColor
};
